<template>
  <div>
    <!-- <div
      class="box is-shadowless pt-0 pb-0"
      style="margin-bottom: 0 !important"
    > -->
      <b-tabs destroy-on-hide v-model="activeTab" @change="onTabChange">
        <b-tab-item
          :label="tab.name"
          v-for="tab in $options.tabs"
          :key="tab.name"
        >
          <router-view />
        </b-tab-item>
      </b-tabs>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  tabs: [
    { name: "LIST", route: "codes.list" },
    { name: "CONFIGURATOR", route: "codes.configurator" },
    { name: "MATRIX MANAGER", route: "codes.matrix-manager" },
    { name: "CHAIN", route: "codes.chain" }
  ],
  data: () => ({
    activeTab: 0
  }),
  created() {
    // Update active tab when user navigates via url
    const matched = this.$router.currentRoute.matched.map(route => route.name);
    const tab = this.$options.tabs.findIndex(tab =>
      matched.includes(tab.route)
    );

    if (tab > -1) {
      this.activeTab = tab;
    } else {
      this.onTabChange(0);
    }
  },
  methods: {
    onTabChange(tab) {
      if (this.$options.tabs[tab]) {
        this.$router.push({ name: this.$options.tabs[tab].route });
      }
    }
  }
};
</script>

<style scoped>
.b-tabs:not(:last-child) {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Codes/index.vue